var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { FileLimit } from "./FileLimit";
export class ZippedFileSizeLimit extends FileLimit {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "MaxSize");
    /**
     */
    __publicField(this, "Unit");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ZippedFileSizeLimit
     */
    __publicField(this, "$type", "V1.Cesop.Configuration.ZippedFileSizeLimit");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      this.MaxSize = _data["MaxSize"];
      this.Unit = ZippedFileSizeLimitUnit[_data["Unit"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["MaxSize"] = this.MaxSize;
    _data["Unit"] = ZippedFileSizeLimitUnit[this.Unit];
    return _data;
  }
}
export var ZippedFileSizeLimitUnit = /* @__PURE__ */ ((ZippedFileSizeLimitUnit2) => {
  ZippedFileSizeLimitUnit2["MegaByte"] = "MegaByte";
  ZippedFileSizeLimitUnit2["GigaByte"] = "GigaByte";
  return ZippedFileSizeLimitUnit2;
})(ZippedFileSizeLimitUnit || {});
